import React from 'react';
import colors from '../styles/colors'; // Assure-toi que 'colors.first' est bien défini
import styled from 'styled-components';

import HomeMain from '../components/Home/HomeMain';
import HomeSidebar from '../components/Home/HomeSidebar';

const StyledHome = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const StyledHomeMain = styled(HomeMain)`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
`;

const StyledSidebar = styled(HomeSidebar)`
  background-color: ${colors.second}; /* Garde cette ligne seulement */
  color: white;
  display: flex;
  width: 500px;
  height: 100vh;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

function Home() {
  return (
    <StyledHome>
      <StyledHomeMain />
      <StyledSidebar />
    </StyledHome>
  );
}

export default Home;
